import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, X } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { useLanguage } from "../context/LanguageContext";

const StickyMobileCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 300px
      if (window.scrollY > 300 && !isDismissed) {
        setIsVisible(true);
      } else if (window.scrollY <= 300) {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isDismissed]);

  const whatsappLink = "https://wa.me/905488484828?text=" + encodeURIComponent(t("floatingWhatsapp.defaultMessage"));

  if (isDismissed) return null;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-0 left-0 right-0 z-50 md:hidden"
          data-testid="sticky-mobile-cta"
        >
          {/* Short Disclaimer for Mobile */}
          <div className="bg-[#0A0A0A]/95 backdrop-blur-sm border-t border-white/5 py-2 px-4">
            <p className="text-center text-gray-600 text-[10px] leading-tight">
              {t("legal.shortDisclaimer")}
            </p>
          </div>

          {/* Gradient background */}
          <div className="bg-gradient-to-t from-[#050505] via-[#050505]/95 to-transparent pt-2 pb-4 px-4">
            <div className="flex gap-3">
              {/* WhatsApp Button */}
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 flex items-center justify-center gap-2 bg-[#25D366] text-white py-4 font-bold text-sm tracking-wider uppercase shadow-lg"
                data-testid="sticky-whatsapp-btn"
              >
                <FaWhatsapp size={20} />
                <span>WhatsApp</span>
              </a>

              {/* Call Button */}
              <a
                href="tel:+905488484828"
                className="flex-1 flex items-center justify-center gap-2 bg-[#00FFFF] text-black py-4 font-bold text-sm tracking-wider uppercase shadow-lg"
                data-testid="sticky-call-btn"
              >
                <Phone size={20} />
                <span>{t("hero.ctaCall")}</span>
              </a>
            </div>
          </div>

          {/* Dismiss button */}
          <button
            onClick={() => setIsDismissed(true)}
            className="absolute top-2 right-4 p-1 text-gray-400 hover:text-white"
            aria-label="Kapat"
          >
            <X size={16} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyMobileCTA;
